import { Modal, notification, Tabs } from 'antd';
import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { Provider } from 'unstated';

import isObjectEmpty from '../../../helpers/isObjectEmpty';
import { LanguageSelect } from '../../../components/Others/LanguageSelect/LanguageSelect';
import GetCurrenciesQuery from '../../../components/Query/Currencies';

import GeneralSettingsTab from './GeneralSettingsTab';
import ProductAccessoriesTab from './ProductAccessoriesTab';
import ProductImagesTab from './ProductImagesTab';
import ProductVariantsTab from './ProductVariantsTab';
// import SeoSettingsTab from './SeoSettingsTab';
import StateContainer from './StateContainer';
import ProductFilesTab from './ProductFilesTab';
import ProductVideosTab from './ProductVideosTab';
import ProductAdvancedTab from './ProductAdvancedTab';
import WatchDogTab from './WatchDogTab';
import RecommendedProductsTab from './RecommendedProductsTab';

const generalTab = '1';
const variantsTab = '2';
const imagesTab = '3';
const filesTab = '4';
const videosTab = '5';
const accessoriesTab = '6';
const seoTab = '7';
const advancedTab = '8';
const recommendedProducts = 'recommendedProducts';
const waitingCustomersTab = 'waitingCustomers';

export interface IProductDetailProps {
  domain: string;
  onSave: () => void;
  onCancel: () => void;
  product?: any;
  productId: string | number;
  createProduct?: MutationFunc<GQL.IMutation>;
  updateProduct?: MutationFunc<GQL.IQuery>;
  deleteProduct?: MutationFunc<GQL.IQuery>;
  removeImage?: MutationFunc<GQL.IQuery>;
  removeFile?: MutationFunc<GQL.IQuery>;
}

interface IProductDetailState {
  activeTab: string;
}

export const isNewProduct = (product: GQL.IProduct) => (product.id === undefined || product.id == '-1');

export default class ProductDetail extends React.Component<IProductDetailProps, IProductDetailState> {

  private productContainer: StateContainer;

  constructor(props: IProductDetailProps) {
    super(props);

    this.onSave = this.onSave.bind(this);
    this.upsert = this.upsert.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.removeFile = this.removeFile.bind(this);

    this.state = {
      activeTab: generalTab
    };
  }

  public render() {
    const loading = this.props.product && this.props.product.loading;
    const product = this.props.product && this.props.product.product;

    if (this.productContainer == undefined) {
      if (!loading && (this.props.productId == undefined || this.props.productId == -1)) {
        this.productContainer = new StateContainer({
          product: {} as GQL.IProduct,
          languages: this.props.product.languages
        });
      } else if (!loading && product != undefined) {
        this.productContainer = new StateContainer({
          product: product,
          languages: this.props.product.languages
        });
      }
    }

    const mustShouldUpdate = (this.state.activeTab == variantsTab 
      || this.state.activeTab == imagesTab 
      || this.state.activeTab == filesTab 
      || this.state.activeTab == videosTab);

    return (
      <Provider>
        <GetCurrenciesQuery>
          {({ primaryCurrency }) => (
            <Modal
              maskClosable={false}
              keyboard={false}
              style={{ top: '5vh' }}
              width={'90%'}
              bodyStyle={{ minHeight: '80vh' }}
              title={
                <>
                  {loading ? 'Loading...' :
                    <>
                      {product == undefined
                        ? 'New product'
                        : <span>Product {product.title} <small style={{ fontWeight: 200 }}>({product.id})</small></span>}&nbsp;&ndash;&nbsp;
                      <LanguageSelect
                        name={'language'}
                        value={this.productContainer.state.currentLanguage}
                        onChange={(e: any, language: GQL.ILanguage) => this.productContainer.setState({ currentLanguage: language.value })}
                        languages={this.productContainer.state.languages}
                      />
                    </>}
                </>
              }
              visible={true}
              cancelText={'Close'}
              okText={'Save changes'}
              onOk={this.onSave}
              confirmLoading={this.productContainer && this.productContainer.state.upserting}
              onCancel={this.props.onCancel}
            >
              {this.productContainer && (
                <Tabs
                  onChange={key => this.onTabChange(key)}
                  activeKey={this.state.activeTab}
                  style={{ marginTop: '-14px' }}
                >
                  <Tabs.TabPane key={generalTab} tab={'General settings'}>
                    <GeneralSettingsTab
                      domain={this.props.domain}
                      shouldUpdate={this.state.activeTab == generalTab || this.state.activeTab == variantsTab}
                      container={this.productContainer}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane key={variantsTab} tab={'Variants'}>
                    <ProductVariantsTab
                      currency={primaryCurrency}
                      shouldUpdate={this.state.activeTab == variantsTab}
                      container={this.productContainer}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane key={imagesTab} tab={'Images'}>
                    <ProductImagesTab
                      shouldUpdate={mustShouldUpdate}
                      removeImage={this.removeImage}
                      container={this.productContainer}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane key={filesTab} tab={'Attachments'}>
                    <ProductFilesTab
                      shouldUpdate={mustShouldUpdate}
                      removeFile={this.removeFile}
                      container={this.productContainer}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane key={videosTab} tab={'Videos'}>
                    <ProductVideosTab
                      shouldUpdate={mustShouldUpdate}
                      container={this.productContainer}
                    />
                  </Tabs.TabPane> 
                  {/* <Tabs.TabPane key={accessoriesTab} tab={'Accessories'}>
                    <ProductAccessoriesTab
                      container={this.productContainer}
                    />
                  </Tabs.TabPane> */}
                  {/* <Tabs.TabPane key={seoTab} tab={'SEO settings'}>
                    <SeoSettingsTab container={this.productContainer} />
                  </Tabs.TabPane> */}
                  <Tabs.TabPane key={advancedTab} tab={'Advanced'}>
                    <ProductAdvancedTab
                      container={this.productContainer}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane key={recommendedProducts} tab={'Recommended products'}>
                    <RecommendedProductsTab
                      container={this.productContainer}
                    />
                  </Tabs.TabPane>
                  {this.props.productId && (this.props.productId != -1) && ('string' === typeof this.props.productId) && <Tabs.TabPane key={waitingCustomersTab} tab={'Waiting customers'}>
                    <WatchDogTab
                      productId={this.props.productId}
                    />
                  </Tabs.TabPane>
                  || ''}
                </Tabs>
              )}
            </Modal>)}
        </GetCurrenciesQuery>
      </Provider>
    );
  }

  private async onSave() {
    for (const tab of [generalTab, variantsTab, imagesTab, accessoriesTab, seoTab]) {
      const valid = await this.isTabValid(tab);
      if (!valid) {
        this.setState({ activeTab: tab });
        return;
      }
    }

    this.upsert(true);
  }

  private async onTabChange(tabKey: string) {
    if (await this.isTabValid(this.state.activeTab)) {
      if (await this.handleSpecialActionWhenLeaving(this.state.activeTab)) {
        this.setState({ activeTab: tabKey });
      }
    }
  }

  private async handleSpecialActionWhenLeaving(key: string) {
    switch (key) {
      case generalTab:
        if (
          this.productContainer.state.product.id == undefined ||
          this.productContainer.state.product.id == '-1'
        ) {
          await this.upsert(false);
        }
        break;
      default:
        break;
    }

    return true;
  }

  private async isTabValid(key: string) {
    switch (key) {
      case generalTab:
        return await this.isValidGeneralSettings();
      default:
        return true;
    }
  }

  private async isValidGeneralSettings() {
    const errors = await this.productContainer.validate(); // TODO
    return isObjectEmpty(errors.generalSettings);
  }

  private async upsert(doneEditing: boolean) {
    if (this.productContainer && !this.productContainer.state.upserting) {
      await this.productContainer.setState({ upserting: true });
    } else {
      return;
    }
    
    const product = this.productContainer.state.product;
    const variables = {
      ...product,
      display: product.displayStatus > 0 ? true : false,
      id: product.id,
      title: product.title,
      description: product.description,
      metaTitle: product.metaTitle,
      metaDescription: product.metaDescription,
      categories: (product.categories || []).map(category => category.id),
      weightForShipping: (!!product.weightForShipping ? product.weightForShipping : null),
      variants: product.variants,
      videos: product.videos ? product.videos.map((video: GQL.IProductVideo) => {
        return {
          url: video.url,
          title: video.title,
          productId: product.id,
          visible: true,
          priority: video.priority,
        }
      }) : null,
      accessories: product.accessoriesToUpdate,
      hideForCountry: product.hideForCountry,
      prices: product.prices ? product.prices.map((price: GQL.IPrice) => {
        return {
          productId: price.productId,
          productVariantId: price.productVariantId,
          countryId: price.countryId,
          currencyId: price.currencyId,
          priceWithout: price.priceWithout,
          availabilityId: price.availabilityId,
          recommendedPriceWithout: price.recommendedPriceWithout,
          discount: price.discount,
          discountPercent: price.discountPercent,
          minimalPrice: Number(price.minimalPrice) === 0 ? null : Number(price.minimalPrice),
          // stockAmount: Number.isNaN(Number(price.stockAmount)) ? null : Number(price.stockAmount),
          // outOfStockTransitionStatusId: price.outOfStockTransitionStatusId || null,

        };
      }) : null,
      neverApplyCustomerDiscounts: product.neverApplyCustomerDiscounts,
      customerGroupsOnlyDiscountIds: product.customerGroupsOnlyDiscountIds,
      externalBlogTags: product.externalBlogTags,
      externalBlogArticleNumber: product.externalBlogArticleNumber || null,
      purchaseLimitPerPurchase: product.purchaseLimitPerPurchase || null,
      purchaseLimitPerPeriod: product.purchaseLimitPerPeriod || null,
    };

    if (product.id != undefined && product.id != '-1' && this.props.updateProduct) {
      await this.props.updateProduct({
        variables
      });

      notification['success']({
        message: 'Info',
        description: `Product "${variables.title}" has been updated.`
      });
    } else if (this.props.createProduct != undefined) {
      const result = await this.props.createProduct({
        variables
      });

      this.productContainer.setState({
        product: { ...this.productContainer.state.product, id: result.data.createProduct.id }
      });

      notification['success']({
        message: 'Info',
        description: `Product "${variables.title}" has been created.`
      });
    }

    if (this.productContainer) {
      await this.productContainer.setState({ upserting: false });
    }

    if (doneEditing) {
      this.props.onSave();
    }
  }

  private async removeImage(obj: { variables: { id: string } }) {
    if (this.props.removeImage == undefined) {
      return;
    }

    await this.props.removeImage(obj);
  }

  private async removeFile(obj: { variables: { id: string } }) {
    if (!this.props.removeFile) {
      return;
    }

    await this.props.removeFile(obj);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductDetail.tsx